/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Mwulire 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Bicumbi": ["Bicumbi", "Gasharu", "Karama", "Manene", "Nyagihanga", "Rwimbogo", "Sabusaro"],
  "Bushenyi": ["Byange", "Kabahima", "Kangaruye", "Rebero", "Rubiha", "Ruseke"],
  "Mwulire": ["Cyome", "Gisanza", "Akagarama", "Kigabiro", "Mpinga", "Munini I", "Munini II", "Rebero"],
  "Ntunga": ["Cyimbazi", "Kabacuzi", "Kadasumbwa", "Karuzigura", "Kiyovu", "Nkira", "Ntunga", "Rugarama", "Rugenge"]
};